define('PDP.Quantity.View', [
    'ProductDetails.Quantity.View'
  ], function (
      View
) {
    'use strict';
  
    return {
        loadModule: function loadModule( container ) {
            _.extend( View.prototype, {
                events: _.extend( View.prototype.events, {
                    'change [id="quantity"]': 'updateMatrixQuantity'
                }),

                initialize: function initialize(options) {
                    var self = this;
                    self.model = options.model;
                    this.pdp = container.getComponent('PDP');

                    // Determine if this is a matrix item by checking for matrixchilditems_detail
                    if (self.model.get('item').get('matrixchilditems_detail')) {
                        // For matrix items, get the first matrix child record and its minimum order quantity
                        var matrixChildItems = self.model.get('item').get('matrixchilditems_detail');
                        var defaultChild = _.first(matrixChildItems);
                        self.isMinimumOrder = !!defaultChild.custitem_mhi_min_order_qty;
                        self.min = self.isMinimumOrder ? parseInt(defaultChild.custitem_mhi_min_order_qty, 10) : 1;

                        // Check if the current quantity (from the URL) is below the minimum
                        var currentQuantity = parseInt(self.model.get('quantity'), 10);
                        if (currentQuantity < self.min) {
                            self.model.set('quantity', self.min);
                            this.pdp.setQuantity(self.min);
                        }
                        self.render();
                    } else {
                        // For non-matrix items, use the parent record's custom field
                        self.isMinimumOrder = !!self.model.get('item').get('custitem_mhi_min_order_qty');
                        self.min = self.isMinimumOrder ? parseInt(self.model.get('item').get('custitem_mhi_min_order_qty'), 10) : 1;

                        var currentQuantity = parseInt(self.model.get('quantity'), 10);
                        if (currentQuantity < self.min) {
                            self.model.set('quantity', self.min);
                            this.pdp.setQuantity(self.min);
                        }
                        self.render();
                    }

                    // Update quantity when an option is selected (for matrix items)
                    this.pdp.cancelableOn('afterOptionSelection', function(option) {
                        var matrixChilds = self.pdp.getSelectedMatrixChilds();
                        if (matrixChilds && matrixChilds.length > 0) {
                            var matrix = _.first(matrixChilds);
                            self.isMinimumOrder = !!matrix.custitem_mhi_min_order_qty;
                            self.min = self.isMinimumOrder ? parseInt(matrix.custitem_mhi_min_order_qty, 10) : 1;
                            self.model.set('quantity', self.min);
                            self.pdp.setQuantity(self.min);
                            self.render();
                        } else {
                            self.render();
                        }
                    });
                },


                updateMatrixQuantity: function() {
                    var $input_quantity = this.$('[name="quantity"]');
                    var new_quantity = parseInt($input_quantity.val(), 10);
                    this.pdp.setQuantity( new_quantity );
                },

                setQuantity: function setQuantity(e) {
                    
                    e.preventDefault();
                    
                    var value = parseInt(this.$(e.currentTarget).data('value'), 10);
                    var $input_quantity = this.$('[name="quantity"]');
                    var old_value = parseInt($input_quantity.val(), 10);
                    var new_quantity = old_value + value;

                    $input_quantity.val(new_quantity).trigger('blur');
                    //console.log(new_quantity)
                    var isMobile = navigator.userAgentData.mobile;
                    if ( isMobile ) {
                        if ( new_quantity > 1) {
                            this.$el
                                .find('.product-details-quantity-remove')
                                .prop('disabled', false);
                        } else {
                            this.$el
                                .find('.product-details-quantity-remove')
                                .prop('disabled', true);
                        }
                    }
                    this.pdp.setQuantity( new_quantity );
                },

                getContext: _.wrap( View.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var self = this;

                    context.isMinimumOrder = self.min > 1;
                    context.quantity = self.min;
                    context.step = self.min;
                    
                    return context;
                })
            });
        }
    }
});
  
